import { Switch } from "antd";
import { useState } from "react";
import { showToast } from "ui/components/common";
import { aiSwitch } from "./service";

export default function AiSwitch({ data }) {
  const [loading, setLoading] = useState(false);
  async function onChange(checked) {
    setLoading(true);
    const res = await aiSwitch(checked, data.organization.id);
    if (res.status !== 200) {
      showToast(1, "Failed to change AI switch");
    } else {
      data.organization.enableAgi = checked;
    }
    setLoading(false);
  }
  return (
    <Switch
      onChange={onChange}
      loading={loading}
      checked={data.organization?.enableAgi}
      checkedChildren="AI Enabled"
      unCheckedChildren="AI Disabled"
      defaultChecked
    />
  );
}
